import * as angular from "angular";
import { PermissionCheck } from "../../../shared/permission";
import { UserPermission } from "../../../utils/user-permissions";

let InvitePermission = {
    selector: "vcInvitePermission",
    templateUrl:
        "/angular/components/invite/sections/invite-permission.component.html",
    bindings: {
        user: "=",
        finishCallback: "&",
        hidePermissions: "=?",
        allowedPermissions: "<?",
        contactMethod: "<?",
        editing: "<?",
    },
    controller: class InvitePermissionController {
        // * bindings for typescript compiler *
        public user: any;
        public finishCallback: Function;
        public hidePermissions: boolean = false;
        public allowedPermissions?: number[];
        public contactMethod?: string;
        public editing?: boolean;
        // ************************************

        public permissionProvider: PermissionCheck;
        public permissions: object[];

        constructor(PermissionCheck: PermissionCheck) {
            this.permissionProvider = PermissionCheck;
            this.permissions = this.permissionProvider.levels;
        }

        selectablePermission(permissionid) {
            let allowedPermissions = this.hidePermissions
                ? [5, 6]
                : [3, 4, 5, 6];
            return allowedPermissions.includes(permissionid);
        }

        // Greys out (disables) a permission when the inviter can't grant it,
        // or when the current contact method restricts the choice (e.g. phone
        // or QR) via the allowedPermissions list.
        isDisabled(permissionid: number): boolean {
            const restricted =
                Array.isArray(this.allowedPermissions) &&
                this.allowedPermissions.length > 0 &&
                !this.allowedPermissions.includes(permissionid);
            return !this.canGrant(permissionid) || restricted;
        }

        // Mirrors InviteUserRequest on the backend: whether a role may invite
        // at all comes from the USER_INVITE feature table, and each inviter
        // level has an explicit list of levels it may grant.
        private canGrant(permissionid: number): boolean {
            if (!this.permissionProvider.featureGrants("USER_INVITE")) {
                return false;
            }

            const inviter = Number(this.permissionProvider.permissionid);
            switch (inviter) {
                // Owners and org-level users
                case UserPermission.ACCOUNT_OWNER:
                case UserPermission.LEADER_OWNER:
                case UserPermission.LEADER_MANAGER:
                case UserPermission.DIVISION_MANAGER:
                case UserPermission.ACCOUNT_MANAGER:
                    return [
                        UserPermission.ACCOUNT_MANAGER,
                        UserPermission.STAFFER,
                        UserPermission.LEAD_ORGANIZER,
                        UserPermission.ORGANIZER,
                    ].includes(permissionid);
                case UserPermission.STAFFER:
                    return [
                        UserPermission.STAFFER,
                        UserPermission.LEAD_ORGANIZER,
                        UserPermission.ORGANIZER,
                    ].includes(permissionid);
                case UserPermission.LEAD_ORGANIZER:
                    return [
                        UserPermission.LEAD_ORGANIZER,
                        UserPermission.ORGANIZER,
                    ].includes(permissionid);
                case UserPermission.ORGANIZER:
                    return permissionid === UserPermission.ORGANIZER;
                default:
                    return false;
            }
        }

        // The API can return the user's permissionid as a string, so
        // coerce before comparing against the numeric permission levels.
        isSelected(permissionid: number): boolean {
            return Number(this.user.permissionid) === permissionid;
        }

        setPermissionName(permission: any): void {
            if (!this.user.permission) this.user.permission = {};
            this.user.permission.permissionid = permission.permissionid;
            this.user.permission.permissionname = permission.internalName;
            this.user.permissionname = permission.internalName;
        }

        // Selecting a permission card sets the model + name in one step.
        select(permission: any): void {
            if (this.isDisabled(permission.permissionid)) {
                return;
            }
            this.user.permissionid = permission.permissionid;
            this.setPermissionName(permission);
        }

        confirm(): void {
            this.finishCallback({ stage: "permission" });
        }
    },
};

angular.module("invite").component(InvitePermission.selector, InvitePermission);
